export default {
  URL: {
    ASSETS: {
      IMG: {
        BG_SECTION_1: 'https://firebasestorage.googleapis.com/v0/b/omiyage-sato.appspot.com/o/home-assets%2Fimg%2Fmidorigaike.jpg?alt=media&token=10f4c617-7ad4-4403-810c-f657342302f7',
        BG_SECTION_2: 'https://firebasestorage.googleapis.com/v0/b/omiyage-sato.appspot.com/o/home-assets%2Fimg%2Fmise_3.jpg?alt=media&token=00c1b084-16d5-4208-9f86-ae0b55fe0795',
        BG_SECTION_3: 'https://firebasestorage.googleapis.com/v0/b/omiyage-sato.appspot.com/o/home-assets%2Fimg%2Fjam_2.JPG?alt=media&token=1ca56571-198d-4b98-a0b0-f59af774aba1',
        BG_SECTION_4: 'https://firebasestorage.googleapis.com/v0/b/omiyage-sato.appspot.com/o/home-assets%2Fimg%2Fski_2.jpg?alt=media&token=5f7787eb-934d-4824-94a0-1e8d88193b2d',
        BG_SECTION_5: 'https://firebasestorage.googleapis.com/v0/b/omiyage-sato.appspot.com/o/home-assets%2Fimg%2Fmise_5.jpg?alt=media&token=11967597-570a-47b7-a617-3bd4714a1ddc',
        BG_SECTION_6: 'https://firebasestorage.googleapis.com/v0/b/omiyage-sato.appspot.com/o/home-assets%2Fimg%2Fmise_4.jpg?alt=media&token=a425806d-5429-437a-b922-8669aef1b66b',
        BG_SECTION_7: 'https://firebasestorage.googleapis.com/v0/b/omiyage-sato.appspot.com/o/home-assets%2Fimg%2Fnews.jpg?alt=media&token=520f26ab-8596-46e8-880a-8a7248f9e079',

        SHOP_ITEM_1: 'https://firebasestorage.googleapis.com/v0/b/omiyage-sato.appspot.com/o/home-assets%2Fimg%2Fshop_2020_1.jpg?alt=media&token=0d55da92-af1b-433d-8e0c-aab981bb1db2',
        SHOP_ITEM_2: 'https://firebasestorage.googleapis.com/v0/b/omiyage-sato.appspot.com/o/home-assets%2Fimg%2Fshop_2020_3.jpg?alt=media&token=c617b064-b8aa-4c6d-baec-d07e015d78fb',
      },
    },
  },
  CONTACT: {
    TO: 'satobussan@gmail.com',
    SUBJECT_PREFIX: '佐藤物産HPからの問い合わせ',
  },
  API: {
    TIMEOUT: 300000,
    BASE_URL: 'https://us-central1-omiyage-sato.cloudfunctions.net/',
    CONTACT: 'contact',
  },
};



// WEBPACK FOOTER //
// ./src/config/constant-home.js